<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-3 align-items-center">
      <!-- Search Input -->
      <div
        class="position-relative"
        :class="canAddGroupToClass ? 'col-md-8' : 'col-md-12'"
      >
        <input
          type="text"
          class="form-control ps-5 form-control-sm"
          :placeholder="$t('groups.searchPlaceholder')"
          v-model="searchTerm"
          @input="handleSearch"
          style="padding-right: 12px;"
          :dir="locale === 'ar' ? 'rtl' : 'ltr'"
        />
        <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
          <i class="fas fa-search"></i>
        </span>
      </div>

      <!-- Add Button -->
      <div class="col-md-4">
        <button
          class="btn btn-secondary btn-sm w-100 d-flex align-items-center justify-content-center gap-2"
          @click="navigateToAddGroup"
          v-can="'class_groups.create'"

        >
          <i class="fas fa-plus"></i>
          <span>{{ addButtonText }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();
const emit = defineEmits(['search', 'add']);
const router = useRouter();
const searchTerm = ref('');
const route = useRoute();

const isClassContext = computed(() => !!route.params.classId);
const classId = computed(() => route.params.classId);

const addButtonText = computed(() =>
  isClassContext.value ? t('groups.addToClass') : t('groups.addNew')
);

const handleSearch = () => {
  emit('search', searchTerm.value);
};

const navigateToAddGroup = () => {
  if (isClassContext.value) {
    router.push(`/classes/${classId.value}/add-group`);
  } else {
    router.push('/groups/add');
  }
};
</script>